module.exports = __webpack_public_path__ + "static/media/logo.d2d734d3.svg";